import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DEFINITION_MAX_LENGTH } from '../../../screening/screening.constants';
import { AppState } from 'src/app/app.state';
import { Store, ActionsSubject } from '@ngrx/store';
import { selectFocusAreaConfigForm } from '../../store/global-settings.selectors';
import {
  clearFocusAreaConfigForm,
  createFocusAreaConfigFromForm,
  createFocusAreaConfigFromFormSuccess,
  loadFocusAreaConfig,
  updateFocusAreaConfigForm,
  updateFocusAreaConfigFormSuccess,
} from '../../store/global-settings.actions';
import { filter, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-risk-assessment-config-form-dialog',
  templateUrl: './risk-assessment-config-form-dialog.component.html',
  styleUrl: './risk-assessment-config-form-dialog.component.scss',
})
export class RiskAssessmentConfigFormDialogComponent {
  private readonly subscriptions = new Subscription();
  formState$ = this.store.select(selectFocusAreaConfigForm);
  readonly focusAreaConfigId?: string;
  readonly DEFINITION_MAX_LENGTH = DEFINITION_MAX_LENGTH;
  readonly title: string = '';

  constructor(
    private store: Store<AppState>,
    private actionsSubject$: ActionsSubject,
    private dialogRef: MatDialogRef<RiskAssessmentConfigFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.focusAreaConfigId = data;
    if (this.focusAreaConfigId) {
      this.store.dispatch(
        loadFocusAreaConfig({
          focusAreaConfigId: this.focusAreaConfigId,
        })
      );
      this.title = 'edit focus area config';
    } else {
      this.store.dispatch(clearFocusAreaConfigForm());
      this.title = 'add focus area config';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeWindow(): void {
    this.dialogRef.close();
  }

  save() {
    this.focusAreaConfigId ? this.update() : this.create();
  }

  private update() {
    this.registerActionSuccess(updateFocusAreaConfigFormSuccess.type);
    this.store.dispatch(
      updateFocusAreaConfigForm({
        focusAreaConfigId: this.focusAreaConfigId!,
      })
    );
  }

  private create() {
    this.registerActionSuccess(createFocusAreaConfigFromFormSuccess.type);
    this.store.dispatch(createFocusAreaConfigFromForm());
  }

  private registerActionSuccess(actionType: string) {
    this.subscriptions.add(
      this.actionsSubject$
        .pipe(filter((action) => action.type === actionType))
        .subscribe(() => {
          this.dialogRef.close();
        })
    );
  }
}
